import { parsePath } from 'history'

export const PARTNER_SCOPE_QUERY_KEYS = ['banners', 'storeConfigs'] as const

export type PartnerScopeQueryKey = (typeof PARTNER_SCOPE_QUERY_KEYS)[number]

export type PartnerScopeQueryValues = Partial<Record<PartnerScopeQueryKey, string[]>>

const EXTERNAL_PATH_PATTERN = /^[a-zA-Z][a-zA-Z\d+\-.]*:/

export const isExternalPath = (pathname: string): boolean =>
  pathname.startsWith('//') || EXTERNAL_PATH_PATTERN.test(pathname)

export const readPartnerScopeParams = (search: string): PartnerScopeQueryValues => {
  const source = new URLSearchParams(search)
  const scope: PartnerScopeQueryValues = {}

  for (const key of PARTNER_SCOPE_QUERY_KEYS) {
    const values = source.getAll(key)
    if (values.length > 0) scope[key] = values
  }

  return scope
}

const buildScopeSuffix = (targetSearch: string, scopeSearch: string): string => {
  const target = new URLSearchParams(targetSearch)
  const suffix = new URLSearchParams()
  const scope = readPartnerScopeParams(scopeSearch)

  for (const key of PARTNER_SCOPE_QUERY_KEYS) {
    if (target.has(key)) continue
    for (const value of scope[key] ?? []) suffix.append(key, value)
  }

  return suffix.toString()
}

export const appendPartnerScopeToPath = (path: string, scopeSearch: string): string => {
  const { pathname, search, hash } = parsePath(path)
  if (isExternalPath(pathname)) return path

  const suffix = buildScopeSuffix(search, scopeSearch)
  if (!suffix) return path

  return `${pathname}${search}${search ? '&' : '?'}${suffix}${hash}`
}
